import React from 'react';

import { AppHeader } from 'src/components/AppHeader';
import { useBuildType, useIsMobile } from 'src/hooks';
import { FloorMarkup, FloorsList } from './components';
import { useStyles } from './styles';
import { useStyles as View2dStyles } from '../View2d/styles';

export const ViewFloors: React.FC = () => {
  const { isCrossTable } = useBuildType();
  const styles = useStyles({});
  const view2dStyles = View2dStyles({ isCrossTable });
  const { isMobileScreen } = useIsMobile();

  return (
    <>
      {isMobileScreen ? (
        <div className={styles.floorsContainerWrapper}>
          <AppHeader wrapperStyles={view2dStyles.mobileHeader} />
          <div className={styles.wrapperFloorControls}>
            <FloorMarkup />
            <FloorsList />
          </div>
        </div>
      ) : (
        <div className={styles.wrapperFloorControls}>
          <FloorMarkup />
          <FloorsList />
        </div>
      )}
    </>
  );
};
